import { default as MuiTable } from '@mui/material/Table';

/**
 * Tables are containers for displaying information that allow users to scan, sort, and compare data.
 *
 * Demos:
 *
 * - [Table](https://unify.workiva.org/components/table?tab=code)
 *
 * API:
 *
 * - [Table API](https://unify.workiva.org/components/table?tab=props)
 */
export const Table = MuiTable;
export { type TableProps, tableClasses } from '@mui/material/Table';
